import backgroundColor from './scriptableOptions/backgroundColor.js';
import borderColor from './scriptableOptions/borderColor.js';
import borderWidth from './scriptableOptions/borderWidth.js';
import radius from './scriptableOptions/radius.js';

export default function scriptableOptions() {
    return {
        //backgroundColor,
        borderColor,
        //borderWidth,
        radius,
    };
}
